import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { CastingState } from '@health-house/features/cast';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { EnvironmentState } from '@shareview-health/configuration';

export function provideAppState(): EnvironmentProviders {
  return importProvidersFrom(
    NgxsModule.forRoot([EnvironmentState, CastingState]),
    NgxsStoragePluginModule.forRoot({ storage: StorageOption.LocalStorage }),
    NgxsLoggerPluginModule.forRoot({ disabled: true }),
    NgxsReduxDevtoolsPluginModule.forRoot({ name: 'Health House - Tizen' })
  );
}
